namespace Solovis.Reports.Parameters {
  //TODO check if these need to be exported
  export interface ColumnItem {
    id: string;
    name: string;
    code: string;
    category: string; // "/" delimitated path
    enabled?: boolean; // default in the left side
    required?: boolean; // will make the item always be on the right and unable to be dragged
  };
  export interface ColumnSelectorControlOptions extends UI.BaseControlOptions {
    renderMode: 'modern';
    initialValue: Array<ColumnItem>;
    settings: { //does this need to have anything?
    }
  };

  /**
   * ColumnSelectorParameterControl presents a list of predetermined options to the user.
   * settings.options: array of {label, value}
   * settings.optionsAsync: function(callback(response, success)) that retrieves a list of options to use as response.result.
   */
  export class ColumnSelectorParameterControl extends Solovis.UI.BaseControl {
    public static hasNewRender = true;
    public initialParameterValue;
    public settings;
    public _optionsToUse: Array<ColumnItem>;
    public _select;
    public _currentValue;

    constructor(options: ColumnSelectorControlOptions, info) {
      super(options, info);

      this.initialParameterValue =
        typeof options.initialValue !== "undefined"
          ? options.initialValue
          : [];

      this.settings = options.settings ? options.settings : {};

      this._optionsToUse = null;
      if (this.settings.options) {
        this._optionsToUse = this.settings.options;
      }
    }

    public async doInitAsync() {
      const self = this;
      if (this._optionsToUse) {
        this.notifyInitComplete();
      } else {
        if (this.settings.optionsAsync) {
          await this.settings.optionsAsync(function (response, success) {
            if (success) {
              self._optionsToUse = response.result;
              if (self.initialParameterValue) {
                self.initialParameterValue.forEach(i => {
                  self._optionsToUse.forEach(o => {
                    if (o.code == i.code) {
                      o.enabled = i.enabled;
                    }
                  })
                })
              }
            }

            self.notifyInitComplete();
          });
        } else {
          self.notifyInitComplete();
        }
      }
    }

    public async doRender() {
      if (this.options.renderMode !== 'modern') {
        // not sure if we want to alert or show a modal or just render some text where the parameter is trying to be placed
        console.error("Column Selector can not be rendered outside the new experience.")
        return;
      }

      const target = this.container[0];
      const self = this;

      await Solovis.UX.Utils.placeComponent("ColumnSelectorControl", target, {
        title: "Edit " + self.info.label,
        values: self._optionsToUse,
        selected: self._optionsToUse.filter(o => o.enabled),
        reorderable: true,
        onSave: (values) => {
          self.setParameterValue(values);
          self.notifyParameterValueChanged();
        },
      });
    }

    public setParameterValue(newValue) {
      this.initialParameterValue = newValue;
    }

    public getParameterValue() {
      return Solovis.deepCopy(this.initialParameterValue);
    }

    public notifyParameterValueChanged() {
      $(this).trigger("parameterValueChanged");
    }
  }
}
